const resources = {
    showMore: 'Show more',
    rougeBadge: 'ROUGE',
    signInToAccess: 'Sign In to Access',
    joinToAccess: 'Join to Access',
    viewAll: 'View All'
};

export default function getResource(label) {
    return resources[label];
}
